"use strict";
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shared = _interopRequireDefault(require("./shared"));

var _edenStyleConstants = require('../../../../eden-style-constants');

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Component = _styledComponents.default.button.withConfig({
  componentId: "sc-1lb7nf5-0"
})(["", ";", " ", ";color:", ";&:hover{background:", ";color:", ";}&:active{", " ", ";}"], _shared.default, ({
  inverted
}) => inverted ? `background: linear-gradient(
        138.17deg, 
        rgba(255, 255, 255, 0) 12.7%, 
        rgba(0, 97, 132, 0.2) 106.8%
  ),` : `background: linear-gradient(
        153.43deg, 
        rgba(255, 255, 255, 0.4) 0%, 
        rgba(255, 255, 255, 0) 83.33%
  ),`, ({
  theme,
  inverted
}) => theme.primaryColor ? theme.primaryColor : inverted ? _edenStyleConstants.white : _edenStyleConstants.blue30, ({
  theme,
  inverted
}) => inverted && !theme.primaryColor ? _edenStyleConstants.blue30 : _edenStyleConstants.white, ({
  theme,
  inverted
}) => theme.primaryColor ? theme.primaryColor : inverted ? _edenStyleConstants.white : _edenStyleConstants.blue30, ({
  theme,
  inverted
}) => inverted && !theme.primaryColor ? _edenStyleConstants.blue30 : _edenStyleConstants.white, ({
  inverted
}) => inverted ? `background: linear-gradient(
          137.89deg, 
          rgba(0, 97, 132, 0.2) -6.82%, 
          rgba(255, 255, 255, 0) 87.48%
      ),` : `background: linear-gradient(
          154.04deg, 
          rgba(255, 255, 255, 0) 16.55%, 
          rgba(255, 255, 255, 0.4) 100%
      ),`, ({
  theme,
  inverted
}) => theme.primaryColor ? theme.primaryColor : inverted ? _edenStyleConstants.white : _edenStyleConstants.blue30);
/**
 * Primary buttons are used to indicate that an action is strongly recommended for a user to complete a specific task.
 */


const Primary = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(Component, _extends({}, props, {
  ref: ref,
  as: props.disabled ? "button" : props.href ? "a" : "button"
}), props.children));

Primary.defaultProps = {
  type: "button"
};
Primary.displayName = "Primary";
Primary.propTypes = {
  /** The button contents */
  children: _propTypes.default.node.isRequired,

  /** Whether to apply styles that help the button stand out on a dark background */
  inverted: _propTypes.default.bool,

  /** Whether to apply smaller styles */
  small: _propTypes.default.bool,

  /** Theme style values */
  theme: _propTypes.default.shape({
    primaryColor: _propTypes.default.string
  }),

  /** The [type of the button](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Attributes), if an href is present it will be the [type of the link](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#Attributes) */
  type: _propTypes.default.string,

  /** If the button should expand to the full width of its parent */
  fullWidth: _propTypes.default.bool,

  /** If the button should be disabled */
  disabled: _propTypes.default.bool,

  /** The link that the button should navigate to on click */
  href: _propTypes.default.string
};
var _default = Primary;
exports.default = _default;